// Angular
import { Pipe, PipeTransform } from '@angular/core';
import { String, StringBuilder } from 'typescript-string-operations';


@Pipe({
	name: 'stringFormat'
})
export class StringFormatPipe implements PipeTransform {

	constructor(
	) {}

	transform(value: string, ...args:any[]) {
        return String.Format(value, ...args) || value;
    }
	

}